import React, { ChangeEvent, useEffect, useState } from 'react'

import Box from '@material-ui/core/Box'
import FormControl from '@material-ui/core/FormControl'
import InputAdornment from '@material-ui/core/InputAdornment'
import makeStyles from '@material-ui/styles/makeStyles'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'

import clsx from 'clsx'

const useTextDebounce = (payload: string, delay = 500): string => {
    const [text, setText] = useState<string>('')

    useEffect(() => {
        const timeOutId = setTimeout(() => setText(payload), delay)

        return () => clearTimeout(timeOutId)
    }, [delay, payload])

    return text
}

const useStyles = makeStyles({
    root: {
        backgroundColor: '#F5F5F5',
        '& fieldset': {
            borderColor: 'transparent !important'
        },
        '& ::placeholder': {
            fontSize: '12px',
            color: '#BDBDBD',
            opacity: '1',
            fontWeight: '600'
        }
    },
    icon: {
        width: '20px'
    },
    closeIcon: {
        color: '#BDBDBD',
        cursor: 'pointer'
    }
})

export type SearchTranscriptProps = {
    /**
     * send search text to parent component
     */
    onChange: (item: string) => void
}

export const SearchTranscript = ({ onChange }: SearchTranscriptProps) => {
    const classes = useStyles()
    const [searchValue, setSearchValue] = useState<string>('')

    const debouncedText = useTextDebounce(searchValue)

    useEffect(() => {
        onChange(debouncedText)
    }, [debouncedText, onChange])

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target?.value || '')
    }

    return (
        <Box
            mb={1}
            id="container"
            style={{ backgroundColor: '#FAFAFA', width: '100%' }}
        >
            <FormControl fullWidth id="form-control">
                <OutlinedInput
                    fullWidth={true}
                    value={searchValue}
                    classes={{
                        root: classes.root
                    }}
                    id="search-transcript"
                    data-cy="search-transcript"
                    margin="dense"
                    onChange={handleChange}
                    startAdornment={
                        <InputAdornment id="search-icon" position="start">
                            <SearchIcon className={classes.icon} />
                        </InputAdornment>
                    }
                    endAdornment={
                        <InputAdornment position="end">
                            <CloseIcon
                                className={clsx(
                                    classes.icon,
                                    classes.closeIcon
                                )}
                                onClick={() => {
                                    setSearchValue('')
                                    onChange('')
                                }}
                            />
                        </InputAdornment>
                    }
                    placeholder="Search for anything"
                />
            </FormControl>
        </Box>
    )
}
